import React from 'react';
import './bodypart.css';
import { NavLink } from 'react-router-dom';
import { FaEye, FaRegCalendarAlt } from 'react-icons/fa';

const Bodypart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <div className="loader-text">Loading content, please wait...</div>
      </div>
    );
  }

  const mainCards = data.slice(0, 3);
  const sideNews = data.slice(2);

  return (
    <div>
      <div className="container1">
        {/* Small cards */}
        <div className="p1">
          {mainCards.slice(0, 2).map((item, index) => (
            <div className={`sp${index + 1} image-card`} key={item.id}>
              <span className={`category tag ${item.category?.name?.toLowerCase().replace(/\s+/g, '') || 'default'}`}>
                {item.category?.name}
              </span>
              <NavLink to={`/blog/${item.slug}`}>
                <img
                  src={`https://api.funfillia.com/${item.image_500x500}`}
                  className={`i${index + 1} image`}
                  alt={item.title}
                  title={item.title}
                />
              </NavLink>
              <div className="overlay">
                <NavLink to={`/blog/${item.slug}`} className='navlink'>
                  <h3 className="headline">{item.title}</h3>
                </NavLink>
                <p className="meta"><FaRegCalendarAlt/> {new Date(item.published_at).toLocaleDateString()} &nbsp; <FaEye/> {item.views_count} views</p>
              </div>
            </div>
          ))}
        </div>

        {/* Large card */}
        <div className="p2">
          {mainCards[2] && (
            <div className="sp3 image-card">
              <span className={`category tag ${mainCards[2].category?.name?.toLowerCase().replace(/\s+/g, '') || 'default'}`}>
                {mainCards[2].category?.name}
              </span>
              <NavLink to={`/blog/${mainCards[2].slug}`}>
                <img
                  src={`https://api.funfillia.com/${mainCards[2].image_500x500}`}
                  className="i3 image2"
                  alt={mainCards[2].title}
                  title={mainCards[2].title}
                />
              </NavLink>
              <div className="overlay">
                <NavLink to={`/blog/${mainCards[2].slug}`} className='navlink'>
                  <h3 className="headline">{mainCards[2].title}</h3>
                </NavLink>
                <p className="meta"><FaRegCalendarAlt/> {new Date(mainCards[2].published_at).toLocaleDateString()} &nbsp; <FaEye/> {mainCards[2].views_count} views</p>
              </div>
            </div>
          )}
        </div>

        {/* Sidebar blogs */}
        <div className="p3">
          <div className="news-tabs">
            <button className="tab active">Top Blogs</button>
          </div>
          {sideNews.slice(0, 5).map((item) => (
            <div className="news-item" key={item.id}>
              <div>
                <NavLink to={`/blog/${item.slug}`}>
                  <img
                    src={`https://api.funfillia.com/${item.image_500x500}`}
                    alt={item.title}
                    title={item.title}
                    className="thumb"
                  />
                </NavLink>
              </div>
              <div className="text">
                <NavLink to={`/blog/${item.slug}`} className='navlink'>
                  <p className="headline">{item.title}</p>
                </NavLink>
                <p className="date"><FaRegCalendarAlt/> {new Date(item.published_at).toLocaleDateString()} &nbsp; <FaEye/> {item.views_count} </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Bodypart;
